// extracted by css-extract-rspack-plugin
export default {"collapsibleLabel":"shared-card-module__collapsibleLabel___SAaw5","isDiscord":"shared-card-module__isDiscord___PjHjr","caret":"shared-card-module__caret___AHNNN"};